import React from 'react';

/**
 * HoldingPage
 *
 * Rendered for every public visitor while maintenance mode is enabled.
 * Retains AGRA Decentralised Storytelling Engine visual identity.
 * No mention of maintenance, technical issues, payment, legal, or commercial matters.
 */
export default function HoldingPage() {
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center relative overflow-hidden"
      style={{ backgroundColor: '#07743F' }}
      data-testid="holding-page"
    >
      {/* Subtle background texture */}
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            'radial-gradient(circle at 20% 20%, #E4E517 0%, transparent 40%), radial-gradient(circle at 80% 80%, #72BF44 0%, transparent 40%)',
        }}
        aria-hidden="true"
      />

      <div className="relative z-10 w-full max-w-2xl mx-auto px-6 py-16 text-center">
        {/* Brand mark — wrapped in a white plate so the green mark reads clearly on green */}
        <div className="flex items-center justify-center mb-14" data-testid="holding-brand">
          <div
            className="inline-flex items-center justify-center bg-white rounded-full shadow-lg"
            style={{ padding: '18px 32px' }}
          >
            <img
              src="/branding/agra-logo.png"
              alt="AGRA"
              className="h-12 sm:h-14 w-auto object-contain"
            />
          </div>
        </div>

        {/* Hairline */}
        <div className="mx-auto mb-10 h-px w-24 bg-[#E4E517]/70" aria-hidden="true" />

        {/* Headline */}
        <h1
          className="display-hero text-white text-4xl sm:text-5xl md:text-6xl mb-8 leading-[1.05]"
          data-testid="holding-heading"
        >
          Platform Temporarily <span className="italic-accent text-[#E4E517]">Unavailable</span>
        </h1>

        {/* Body copy */}
        <div className="body-prose mx-auto text-[17px] sm:text-lg text-white/85 leading-relaxed space-y-4">
          <p data-testid="holding-line-1">
            The AGRA Decentralised Storytelling Engine is temporarily unavailable.
          </p>
          <p data-testid="holding-line-2">
            If you require assistance, please contact the platform administrator.
          </p>
          <p className="pt-4 text-white/60" data-testid="holding-line-3">
            Thank you for your understanding.
          </p>
        </div>

        {/* Hairline */}
        <div className="mx-auto mt-14 mb-8 h-px w-24 bg-white/20" aria-hidden="true" />

        {/* Partner lockup */}
        <div className="flex justify-center" data-testid="holding-partner-lockup">
          <img
            src="/branding/in-partnership-lockup-reversed.png"
            alt="AGRA in partnership with Mastercard Foundation"
            className="h-14 sm:h-16 w-auto object-contain opacity-95"
            onError={(e) => {
              e.currentTarget.src = '/branding/in-partnership-lockup.png';
            }}
          />
        </div>

        <p className="mt-8 text-xs uppercase tracking-[0.28em] text-white/40" data-testid="holding-programme-tag">
          AGRA Decentralised Storytelling Engine
        </p>
      </div>
    </div>
  );
}
